/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const PTAccountType = PropTypes.oneOf([
  'REGISTERED',
  'REGISTERED_SMZ',
  'AUTHORIZED',
  'AUTHORIZED_SMZ',
  'EDO',
  'EDO_SMZ',
  'IDENTIFIED',
]);
